import { FlexBox } from "@/components/baseComponents/FlexBox";
import { Stack, styled } from "@mui/material";

export const StyledContainer = styled(FlexBox)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  width: "100%",
  padding: "24px",
  flexDirection: "column",
  borderRadius: "12px",
  rowGap: "16px",

  [theme.breakpoints.down("desktop")]: {
    padding: "16px 16px 24px 16px",
  },
}));

export const StyledVideoContainer = styled(Stack)(({ theme }) => ({
  alignSelf: "center",
  alignItems: "center",

  "> video": {
    width: "360px",
    aspectRatio: "1 / 1",

    [theme.breakpoints.down("desktop")]: {
      width: "min(270px, 100%)",
    },
  },
}));
